import {
  getApiUrl,
  getUsersProfilePhotoContextIdentityUserPublicIDPath,
  getUsersProfilePhotoUserPublicIDPath,
} from "Infrastructure/Api/Api";

export const getProfilePhotoUrl = (
  userPublicID: string | undefined,
  version: string | null | undefined,
) =>
  version && userPublicID
    ? `${getApiUrl()}${getUsersProfilePhotoUserPublicIDPath(userPublicID)}?v=${encodeURIComponent(version)}`
    : undefined;

export const getContextProfilePhotoUrl = (
  identityUserPublicID: string | null | undefined,
  version: string | null | undefined,
) =>
  version && identityUserPublicID
    ? `${getApiUrl()}${getUsersProfilePhotoContextIdentityUserPublicIDPath(identityUserPublicID)}?v=${encodeURIComponent(version)}`
    : undefined;

/**
 * Avatar of the signed-in user: the active role context's photo. The person-level route is a
 * legacy fallback for non-migrated users (no context PublicID yet).
 */
export const getAvatarPhotoUrl = (
  userPublicID: string | undefined,
  activeContextPublicID: string | null | undefined,
  version: string | null | undefined,
) =>
  activeContextPublicID
    ? getContextProfilePhotoUrl(activeContextPublicID, version)
    : getProfilePhotoUrl(userPublicID, version);
